/**
 * Calcula o período de vigência de um cupom interno.
 * Lógica pura, sem mutação: recebe o início e a duração em meses e devolve
 * início e fim. (Antes o código mutava o objeto `now` com setMonth, fazendo
 * início e fim apontarem para a MESMA data futura.)
 */
export function computeCouponPeriod(start, months) {
  const startDate = start instanceof Date ? new Date(start.getTime()) : new Date(start);
  const monthsToAdd = Math.max(1, parseInt(String(months), 10) || 1);
  const endDate = new Date(startDate.getTime());
  endDate.setMonth(endDate.getMonth() + monthsToAdd);
  return { currentPeriodStart: startDate, currentPeriodEnd: endDate };
}
